import { api } from "@/services/api"
import { queryClient } from "@/queryClient"

export type AcceptInviteRequest = {
  firstName: string
  lastName: string
  phone: string | null
  password: string
}

export const acceptInvite = async (
  inviteToken: string,
  params: AcceptInviteRequest
) => {
  const normalizedPhone = params.phone?.trim() || null

  await api.post(
    `/beepaidgo/invites/${inviteToken}/accept/`,
    {
      body: {
        firstName: params.firstName,
        lastName: params.lastName,
        phone: normalizedPhone,
        password: params.password,
      },
    }
  )

  queryClient.invalidateQueries([CURRENT_USER_QUERY_KEY])
  queryClient.invalidateQueries([USERS_QUERY_KEY])
  queryClient.invalidateQueries([CURRENT_TENANT_QUERY_KEY])
}
